/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { StaticImage } from 'gatsby-plugin-image';

import './style.scss';

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <link rel="manifest" href="/manifest.json" />
        <script>
          {`
        // GTM
        (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start':
                new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-MQDJ2TK');
        `}
        </script>
      </Helmet>
      <header>
        <div class="inner">
          <div class="header-logo">
            <StaticImage
              src="../images/header_logo.svg"
              placeholder="none"
              alt="日経転職版"
            />
          </div>
          <div class="transitionBtn">
            <a
              href="https://career.nikkei.com/career/MEFD001/MEFD00101.htm"
              target="_blank"
              rel="noreferrer"
            >
              会員登録はこちら<span>無料</span>
            </a>
          </div>
        </div>
      </header>
      {children}
      <footer>
        <p class="f-about"><a href="https://www.nikkeihr.co.jp/" target="_blank">会社概要</a></p>
        <p class="copy font-noto">
          Nikkei HR, Inc. No reproduction without permission.
        </p>
      </footer>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
